import { OfficeWithPersona, OperationImprovementStats, RevenueSimulationSetting } from "@/models/goFurther";
import { AxiosResponse } from "axios";
import { httpClient } from "./API";

export const getOfficesWithPersonaAPI = async (): Promise<AxiosResponse<OfficeWithPersona[]>> => {
  return httpClient.get("/core/internal/calgary/revenueSimulation/offices");
};

export const getBaseNonEvRevenueAPI = async (officeId: number): Promise<AxiosResponse<RevenueSimulationSetting>> => {
  return httpClient.get(`/core/internal/calgary/revenueSimulation/${officeId}/baseNonEvRevenue`);
};

export const postOperationImprovementStatsAPI = async (
  officeId: number,
  baseNonEvRevenue: number,
): Promise<AxiosResponse<OperationImprovementStats>> => {
  return httpClient.post(`/core/internal/calgary/revenueSimulation/${officeId}`, {
    baseNonEvRevenue,
  });
};
